import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { FC } from 'react'
import { buildContactUsHref } from '../../common/contact-us-link'

export interface PdMetaContactUsButtonProps {
  className?: string
  robotCode?: string
}

const PdMetaContactUsButton: FC<PdMetaContactUsButtonProps> = ({ className, robotCode }) => {
  const t = useTranslations()
  const link = buildContactUsHref(robotCode)
  return (
    <Link href={link}>
      <button
        className={[
          'event-trigger',
          'w-full h-15 font-semibold text-lg rounded-1',
          'laptop:w-75 laptop:h-17 laptop:text-2xl laptop:rounded-1',
          'm-0 p-0 bg-[#0066ff] text-white',
          className ? className : '',
        ].join(' ')}
        data-event-key="event"
        data-event-value="initiate_lead"
      >
        {t('ContactUs')}
      </button>
    </Link>
  )
}

export default PdMetaContactUsButton
